(ns common.schema.entities.counterparty-diligence.common
  (:require [common.schema.schema-utils :as su]))

(def diligence-status-options
  (->>
   [{:value :counterparty-diligence.status/draft
     :label "Draft"}
    {:value :counterparty-diligence.status/sent-to-responders
     :label "Sent to responders"}
    {:value :counterparty-diligence.status/waiting-for-e-sign
     :label "E-Signature"}
    {:value :counterparty-diligence.status/review
     :label "Review"}
    {:value :counterparty-diligence.status/completed
     :label "Completed"}]
   (mapv (fn [{:keys [value] :as opt}]
           (assoc opt :key value)))))

(def yes-no-options
  [{:key   :yes
    :value :yes
    :label "Yes"}
   {:key   :no
    :value :no
    :label "No"}])

(def schema
  (concat
   (su/keyword-field :counterparty-diligence/status
                     "Diligence status"
                     diligence-status-options
                     {:authorization            su/access-system-user
                      :default-field-visibility :in-use-disabled
                      :editor-type              :editor.type/none})

   (su/keyword-field :counterparty-diligence/e-signature-required
                     "E-Signature required?"
                     yes-no-options
                     {:authorization            su/access-user-user
                      :mandatory-config         :mandatory/always
                      :system-required?         true
                      :system-semantics
                      su/user-provided-system-required-field-semantics
                      :default-field-visibility :in-use-disabled})

   ;; TODO: rename responder -> responders
   (su/multi-ref-field :counterparty-diligence/responder
                       "Responders"
                       [:entity.type/person]
                       ;; Responders must be added and removed via separate flow,
                       ;; So disable in default forms
                       {:authorization su/access-system-user
                        :default-field-visibility :in-use-disabled})

   (su/datetime-field :counterparty-diligence/last-email-sent
                      "Last email sent"
                      {:authorization            su/access-system-user
                       :default-field-visibility :in-use})

   (su/text-multiline-field :counterparty-diligence/note
                            "Note"
                            {:authorization            su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :counterparty-diligence/processes
                       "Processes"
                       [:entity.type/counterparty-diligence-process]
                       {:default-field-visibility   :in-use-disabled
                        :hidden-from-configuration? true
                        :editor-type                :editor.type/none
                        :grid-type                  :editor.type/none
                        :filter-type                :filter.type/none})))
